<template>
  <div id="app">
    <router-view :key="$route.fullPath"/>
  </div>
</template>

<script>
import {getWebSiteInfo} from '@/api'
export default {
  name: 'App',
  created() {

  },
  beforeCreate() {
  },
  mounted() {
    getWebSiteInfo().then(res => {
      if (res.code == 0) {
        this.$store.commit("setWebInfo", res.data);
      }
    }).catch(err => {
      console.log(err);
    });
  },
}
</script>

<style lang="scss" scoped>
#app {
  background: var(--body-color);
}
</style>
